import React, { useState } from "react";
import Nav from "../Nav";
import { LuMenu } from "react-icons/lu";

const PageWraper = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  return (
    <>
      <div className="bg-secondary min-vh-100 position-relative">
        <div className="page-wrapper">
          <div className="container">
            {/* Header: Sidebar Toggle */}

            {/* Desktop Toggle */}
            <button
              className="btn btn-outline-secondary border-0 px-2 d-none d-lg-inline-flex"
              onClick={() => setIsSidebarOpen(!isSidebarOpen)}
              title="Toggle Sidebar"
            >
              <LuMenu size={24} />
            </button>

            {/* Mobile Toggle */}
            <button
              className="btn btn-outline-secondary border-0 px-2 d-lg-none"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#sidebarAccount"
              aria-controls="sidebarAccount"
              title="Open Sidebar"
            >
              <LuMenu size={24} />
            </button>
            <div className="row pt-sm-2 pt-lg-0">
              <Nav isOpen={isSidebarOpen} />

              {/* Pass isSidebarOpen to children so they can adjust width */}
              {React.Children.map(children, child =>
                React.isValidElement(child)
                  ? React.cloneElement(child, { isSidebarOpen })
                  : child
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PageWraper;
